export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./dialog.vue?vue&type=template&id=cdbdd6e2&"


//////////////////
// WEBPACK FOOTER
// ./src/components/dialog/dialog.vue?vue&type=template&id=cdbdd6e2&
// module id = null
// module chunks = 